/* eslint-disable react-hooks/rules-of-hooks */
import useTranslation from '@/hooks/i18n';

export const compare = (value1?: string, value2?: string) => {
  return (
    value1?.toString().toUpperCase() === value2?.toUpperCase() ||
    value1?.toString().toUpperCase() ===
      useTranslation()
        .t(value2 || '')
        .toUpperCase()
  );
};
